import $ from 'jquery';
import { bind } from '@ember/runloop';
import { Promise } from 'rsvp';
export default function (url) {
  return new Promise(function (resolve, reject) {
    let img = document.createElement('img');
    let $img = $(img);
    $img.on('load', bind(this, function () {
      resolve({
        url,
        width: img.width,
        height: img.height
      });
      $img.off('load');
    }));
    $img.on('error', bind(this, function () {
      reject('Failed to load url');
      $img.off('load');
    }));
    img.src = url;
  });
}